'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.usermanual.add', [])
  .controller('UsermanualAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/usermanual/add/index.js